import * as yup from 'yup';

import {
    emailValidationRule,
    firstNameValidationRule,
    lastNameValidationRule,
    ageValidationRule,
    passwordValidationRule,
} from './validationRules';

export const userProfileSchema = yup.object({
    firstName: firstNameValidationRule,
    lastName: lastNameValidationRule,
    email: emailValidationRule,
    age: ageValidationRule,
    brokerageLicenseNumber: yup
        .string()
        .required('Please enter your license number')
        .transform((value) => value || undefined),
    brokerageName: yup
        .string()
        .required('Please enter your brokerage name')
        .transform((value) => value || undefined),
    zip: yup
        .string()
        .required("ZIP code can't be blank")
        .transform((value) => value || undefined),
    newPassword: yup.lazy((value) => {
        if (value) {
            return passwordValidationRule;
        }
        return yup.mixed().notRequired();
    }),
    currentPassword: yup.lazy((value) => {
        if (value) {
            return passwordValidationRule;
        }
        return yup.mixed().notRequired();
    }),
});
